import React from 'react';
import clsx from 'clsx';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import { ThemeConsumer, ThemeProvider } from 'styled-components';
import { createTheme } from '@mui/material';

const useStyles = createTheme((theme) => ({
  formControl: {
    display: 'flex',flexWrap: 'wrap'
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      margin: 6,
      width: 250,
    },
  },
};
//maxHeight: ITEM_HEIGHT * 7 + ITEM_PADDING_TOP,

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

// Need to put the id in this paramater, and put it in the triggerUpdateInparent first paramter, not on the field itself
export default function MultipleSelect({handleTranslationTypeChanges, id, triggerUpdateInParent, choices, label, valueInField, classesToAdd}) {
  //const classes = useStyles();
  //const theme = useTheme();
  const [personName, setPersonName] = React.useState(valueInField);

  const handleChange = (event) => {
    let val = event.target.value;
    setPersonName(val);
    let tempArray = val.toString().split(",");
    handleTranslationTypeChanges(tempArray) // old
    if (triggerUpdateInParent) triggerUpdateInParent(id, event.target.value)
  };

  /* 
  const handleChangeMultiple = (event) => {
    const { options } = event.target;
    const value = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    //handleTranslationTypeChanges(value) // new
    setPersonName(value);
    if (triggerUpdateInParent) triggerUpdateInParent(id, event.target.value)
  };*/

  console.log("CHOICES");
  console.log(choices)
  console.log("-------")

  return (
    <div>
      <ThemeProvider theme={useStyles}>
      <FormControl>{/*} className={classes.formControl}>*/}
        <InputLabel id="demo-mutiple-checkbox-label" className={classesToAdd}><b style={{color: '#3f51b5 !important'}}>{label}</b></InputLabel>
        <Select
          labelId="demo-mutiple-checkbox-label"
          id="demo-mutiple-checkbox"
          multiple
          value={personName}
          onChange={handleChange}
          input={<Input />}
          defaultValue={"valueInField"}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={MenuProps}
        >
          {choices.map((name) => (
            <MenuItem key={name} value={name}>
              <Checkbox checked={personName.indexOf(name) > -1} />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      </ThemeProvider>
    </div>
  );
}
